'use client';

import { useDetailsDrawerStore } from '../../store';

import { DetailsDrawer } from './DetailsDrawer';

const DrawerLayout = () => {
  const isDrawerOpen = useDetailsDrawerStore((state) => state.isDrawerOpen);

  return <>{isDrawerOpen ? <DetailsDrawer /> : null}</>;
};

export { DrawerLayout };
